/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paste_Text_Empty_ErrorInputs */

const en_mobile_paste_text_empty_error = /** @type {(inputs: Mobile_Paste_Text_Empty_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste text before converting.`)
};

const es_mobile_paste_text_empty_error = /** @type {(inputs: Mobile_Paste_Text_Empty_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega texto antes de convertir.`)
};

/**
* | output |
* | --- |
* | "Paste text before converting." |
*
* @param {Mobile_Paste_Text_Empty_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text_empty_error = /** @type {((inputs?: Mobile_Paste_Text_Empty_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_Text_Empty_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text_empty_error(inputs)
	return en_mobile_paste_text_empty_error(inputs)
});